import styled from 'styled-components';
import { Typography } from '../../global/theme';
import { FlexCenter } from '../../global/commonStyle';

const ProgressBarWrapper = styled.div`
  width: 100%;
  ${FlexCenter}
  gap: var(--space-8);
`;

const ProgressContainer = styled.div<{ height?: number }>`
  width: 100%;
  height: ${({ height }) => height || 5}px;
  background-color: var(--border-primary);
  border-radius: var(--border-radius-full);
  overflow: hidden;
  position: relative;
`;

const ProgressFill = styled.div<{ percent: number; progressColor?: string }>`
  width: ${({ percent }) => percent}%;
  height: 100%;
  background-color: ${({ progressColor }) => progressColor || 'var(--primary-color)'};
  border-radius: var(--border-radius-full);
  transition: width var(--transition-normal) ease-in-out;
`;

const ProgressInfo = styled.div`
  ${Typography.body_sm}
  color: var(--text-primary);
`;

export { ProgressBarWrapper, ProgressContainer, ProgressFill, ProgressInfo };
